<template>
    <div class="page">
        <dv-full-screen-container>
            <div id="top-header">
                <dv-decoration-8 class="header-left-decoration" />
                <dv-decoration-5 class="header-center-decoration" />
                <dv-decoration-8 class="header-right-decoration" :reverse="true" />
                <div class="center-title">{{user.name == 'xinjian' ? '新建区节能减排云平台' : "节能减排云平台"}}</div>
            </div>
            <div class="main-container" style="background-color:#00093a;height: 100vh;">
                <div class="table">
                    <div class="table-button" @click="home">
                        <!-- <dv-border-box-10 :color="['#04d0f5','#04d0f5']">
                            <div class="table-text">返回首页</div>
                        </dv-border-box-10> -->
                    </div>
                    <div class="table-button" @click="LoginOut()">
                        <dv-border-box-10 :color="['#04d0f5','#04d0f5']">
                            <div class="table-text"> 退出登录</div>
                        </dv-border-box-10>
                    </div>
                </div>
                <div class="main">
                    <div class="upper-part">
						<div class="left-top-echart">
						    <div class='left-num'>
						        <div class="num-title">
						            <div style="width: 1.2rem;height: 1.2rem;border-radius: 50%;background-color: #00d16c;"></div>
						            <div style="color: #00d16c;font-size: 1.4rem;margin-left: 0.8rem;font-weight: 500;">累计碳排放减少</div>
						        </div>
						        <div class="num-text">
						            {{((orderQuerySum ? orderQuerySum.total_power.toFixed(2): 0) * 0.997 * multiple).toFixed(2)}} <span style="font-size: 1rem;margin-left: 0.6rem;color: #00d16c;">kg</span>
						        </div>
						        <div class="num-icon">
						            <img src="../../assets/c1.png" style="width: 40%;"/>
						        </div>
						    </div>
						    <div class='left-num' style="margin-top: 3%;">
						        <div class="num-title">
						            <div style="width: 1.2rem;height: 1.2rem;border-radius: 50%;background-color: #00a991;"></div>
						            <div style="color: #00a991;font-size: 1.4rem;margin-left: 0.8rem;font-weight: 500;">今日碳排放减少</div>
						        </div>
						        <div class="num-text">
						            {{((dayOrderSummary ? dayOrderSummary[0].power.toFixed(2): 0) * 0.997 * multiple).toFixed(2)}} <span style="font-size: 1.4rem;margin-left: 0.6rem;color: #00a991;">kg</span>
						        </div>
						        <div class="num-icon">
						            <img src="../../assets/c2.png" style="width: 40%;"/>
						        </div>
						    </div>
						    <div class='left-num' style="margin-top: 3%;">
						        <div class="num-title">
						            <div style="width: 1.2rem;height: 1.2rem;border-radius: 50%;background-color: #6cc2fd;"></div>
						            <div style="color: #6cc2fd;font-size: 1.4rem;margin-left: 0.8rem;font-weight: 500;">今日电量</div>
						        </div>
						        <div class="num-text">
						            {{dayOrderSummary ? (dayOrderSummary[0].power * multiple).toFixed(2) : 0}} <span style="font-size: 1rem;margin-left: 0.6rem;color: #6cc2fd;">KW.H</span>
						        </div>
						        <div class="num-icon">
						            <img src="../../assets/c3.png" style="width: 30%;"/>
						        </div>
						    </div>
						</div>
						<div class="map">
						    <dv-border-box-12>
						        <div style="padding: 1%;width: 100%;height: 100%;display: flex;justify-content: center; align-items:center;" @contextmenu.prevent.stop="rightClick($event)">
						            <AMap ref="amap" @clickRight="clickRight" @hideSearch="hideSearch"/>
						        </div>
						    </dv-border-box-12>
						</div>
						<div class="right-top-echart">
						    <div class="title" style="height: 6%;position: absolute;">
						        <div class="title-text">{{new Date().getMonth()+1}}月各站点减少碳排放量占比</div>
						    </div>
						    <div class="board">
						        <ElectricEchart/>
						    </div>
						</div>
					</div>
					<div class="next-part">
						<div class="left-bottom-echart">
							<dv-border-box-12>
								<SitePowerTable/>
							</dv-border-box-12>
						</div>
						<div class="right-bottom-echart">
							<dv-border-box-12>
								<MoneyEchartDataV2/> 
							</dv-border-box-12>
						</div>
					</div>
                </div>
            </div>
        </dv-full-screen-container>
		<div class="menu" :style="{
			position: 'fixed',
			left: itemLeft,
			top: itemTop,
			opacity: opacity
		}">
			<select-site
			    @choose="chooseSite"
			    :selectSite="selectSite"
			    :size="'small'"
			    :width="'15rem'"
			    class="ml-3"
			/>
		</div>
    </div>
</template>

<script>
import util from "@/util";
import store from "@/store";
import { mapState } from "vuex";
import screenfull from 'screenfull'
import MapEchart from "@/components/Echarts/MapEchart";
import AMap from "@/components/AMap"
import MoneyEchartDataV2 from "@/components/Echarts/MoneyEchartDataV2";
import ElectricEchart from "@/components/Echarts/ElectricEchart"
import SitePowerTable from "@/components/Echarts/SitePowerTable"
import SelectSite from "@/components/SelectSite";
export default {
    name: "DataV",
    components: {
        MapEchart,
        AMap,
        MoneyEchartDataV2,
		ElectricEchart,
		SitePowerTable,
		SelectSite
    },
    computed: {
        ...mapState(["siteOrderSummary",'dayOrderSummary','orderQuerySum','user','multiple']),
    },
    data() {
        return {
			itemLeft: '20px',
			itemTop: '20px',
			opacity: 0,
			selectSite: null, //选择的站点id
            isFullscreen: false,  //是否为全屏状态
            screenWidth: document.body.clientWidth, // 屏幕宽度
            screenHeight: document.body.clientHeight, // 屏幕高度
            config: {
                data: [
                    // {
                    //   name: '周口',
                    //   value: 55123
                    // },
                    // {
                    //   name: '南阳',
                    //   value: 12022
                    // },
                    // {
                    //   name: '西峡',
                    //   value: 78932
                    // },
                    // {
                    //   name: '驻马店',
                    //   value: 63411
                    // },
                    // {
                    //   name: '新乡',
                    //   value: 44231
                    // }
                ],
                unit: 'kw.h',
            }
        }
    },
    created() {
        // 监听事件
        window.addEventListener('resize', this.onresize)
        window.addEventListener('keydown', this.keydown)
       
    },
    beforeDestroy() {
        // 取消监听事件
        window.removeEventListener('resize', this.onresize)
        window.removeEventListener('keydown', this.keydown)
        
    },
    mounted() {
        this.getMonthOrderSummary()
        this.getDayOrderSummary()
        this.getOrder()
        // console.log(this.screenWidth)
        store.commit("SET_SHOW_NAVIGATION", false);
        // screenfull.toggle()
		// console.log(screenfull.isFullscreen)
        // console.log(document.documentElement.clientWidth)
        // console.log(document.documentElement.clientHeight)
        
        // console.log(document.body.clientWidth)
        // console.log(document.body.clientHeight)
    },
    methods: {
		LoginOut() {
			store.commit("LOG_OUT");
		},
		/*选择充电站*/
		chooseSite(site) {
		    console.log(site)
			this.$refs.amap.setCenter(site)
		},
		// 右键显示搜索框
		clickRight(e) {
			console.log(e)
			this.itemLeft = e.clientX + 'px'
			this.itemTop = e.clientY + 'px'
			this.opacity = 1
		},
		// 隐藏搜索框
		hideSearch() {
			this.itemLeft = '20px'
			this.itemTop = '20px'
			this.opacity = 0
		},
        home() {
            this.$router.go(-1);
        },
        //切换全屏
        handleFullScreen() {
            if (!screenfull.isEnabled) {
                console.log("您的浏览器版本过低，不支持全屏浏览")
                return false;
            }
            screenfull.toggle();
            this.isFullscreen = !this.isFullscreen;
        },
        // 阻止F11默认事件
        keydown(event) {
          if (event.keyCode === 122) {
            event.preventDefault()
            event.returnValue = false
          }
        },
        
        /**
         * 响应屏幕变化事件，给isFullscreen赋值，标识是否全屏
         * IE中bug: 调试器打开，且与页面不分离时 -- 无效
         * **/
        onresize(event) {
          // 利用屏幕分辨率和window对象的内高度来判断兼容IE
          let winFlag = window.innerHeight === window.screen.height
          // 利用window全屏标识来判断 -- IE无效
          let isFull = window.fullScreen || document.webkitIsFullScreen   
          if (isFull === undefined) {
            this.isFullscreen = winFlag
          } else {
            this.isFullscreen = winFlag || isFull
          }
          console.log('winFlag || isFull', winFlag, isFull)
        },
        /*获取 所有电量*/
        async getOrder() {
            let params = {
                postData: {},
                callback: () => {},
            };
            await store.dispatch("getOrderQuerySum", params);
            console.log(this.orderQuerySum);
        },
        async getSiteOrderSummary() {
            let date = new Date()
            let year = date.getFullYear()
            let month = date.getMonth()
            let start_time = new Date(year,month,1).getTime()
            let end_time = new Date(year,month+1,0).getTime()
            // console.log(start_time)
            // console.log(end_time)
            let params = {
                postData: {
                    end_time: parseInt(end_time / 1000),
                    start_time: parseInt(start_time / 1000),
                    sum_type: 2,
                },
                callback: () => {
                   
                },
            };
            await store.dispatch("getOrderSummary", params);
        },
        /*获取 天 的金额电量相关数据报表数据*/
        async getDayOrderSummary() {
            let end_time = new Date().getTime();
            let start_time = new Date(new Date().toLocaleDateString()).getTime();
            // console.log(end_time)
            // console.log(start_time)
            let params = {
                postData: {
                    end_time: parseInt(end_time / 1000),
                    start_time: parseInt(start_time / 1000),
                    sum_type: 0,
                },
                callback: () => {
                    // this.rankLoading = false;
                },
            };
            await store.dispatch("getOrderSummary", params);
            console.log(this.dayOrderSummary)
        },
        /*获取 月 的金额电量相关数据报表数据*/
        async getMonthOrderSummary() {
            let params = {
                postData: {
                    end_time: parseInt(new Date(this.getYear('e')).getTime() / 1000),
                    start_time: parseInt(new Date(this.getYear('s')).getTime() / 1000),
                    sum_type: 1,
                },
                callback: () => {
                   
                },
            };
            await store.dispatch("getOrderSummary", params);
        },
        /**
         * @description 得到今年、去年、明年的开始、结束日期
         * @param {String} type 有两种选择，"s"代表开始,"e"代表结束
         * @param {Number} dates 不传或0代表今年，-1代表去年，1代表明年
         */
        getYear(type, dates) {
          const dd = new Date();
          const n = dates || 0;
          const year = dd.getFullYear() + Number(n);
          let day;
          if (type === 's') {
            day = `${year}-01-01`;
          }
          if (type === 'e') {
            day = `${year}-12-31`;
          }
          if (!type) {
            day = `${year}-01-01/${year}-12-31`;
          }
          return day;
        },
    },
}
</script>

<style lang="scss" scoped>
 // height: calc(100% - 80px);
.menu {
	position: fixed;
	left: 1rem;
	top: 1rem;
	// width: 10rem;
	// height: 3rem;
	// background-color: red;
	z-index: 10000;
	opacity: 0;
}
.page {
    // width: 100%;
    height: 100vh;
	background-color: #00093a;
	position: relative;
    #dv-full-screen-container {
        // background-color: #00093a;
        background-size: 100% 100%;
        box-shadow: 0 0 3px blue;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    #top-header {
      position: relative;
      width: 100%;
      height: 6%;
      display: flex;
      justify-content: space-between;
      flex-shrink: 0;
      // background-color: red;
      .header-center-decoration {
        width: 40%;
        // height: 50px;
        margin-top: 30px;
      }
      .header-left-decoration, .header-right-decoration {
        width: 25%;
        // height: 50px;
      }
      .center-title {
        position: absolute;
        font-size: 1.2rem;
        font-weight: bold;
        left: 50%;
        top: 15px;
        transform: translateX(-50%);
        color: #04d0f5;
      }
    }
    .main-container {
        display: flex;
        flex-direction: column;
        background-color: #00093a;
        // padding: 1rem 0 0 0;
        width: 100%;
        height: 93%;
        .table {
            width: 100%;
            height: 6%;
            padding: 0 1.5rem;
            // border:1px solid red;
            // background-color: blue;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .table-button {
                width: 5.5em;
                height: 2em;
                // background-color: red;
                .table-text {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #fff;
                    font-size: 0.6rem;
                }
            }
            .home {
                
            }
            .screen {
                
            }
        }
        .main {
            width: 100%;
            height: 94%;
            display: flex;
            flex-direction: column;
			.upper-part {
				width: 100%;
				height: 60%;
				display: flex;
				flex-direction: row;
				padding: 0 1%;
				.left-top-echart {
				    width: 25%;
				    height: 98%;
				    display: flex;
				    flex-direction: column;
				    // background-color: red;
				    padding: 0 0 1% 0;
				    .left-num {
				        width: 100%;
				        height: 32%;
				        background-image: url(../../assets/datav-num-bg.png);
				        background-size: 100% 100%;
				        position: relative;
				        .num-title {
				            position: absolute;
				            left: 7%;
				            top: 16%;
				            // background-color: red;
				            min-width: 60%;
				            height: 25%;
				            display: flex;
				            flex-direction: row;
				            align-items: center;
				        }
				        .num-text {
				            position: absolute;
				            left: 7%;
				            bottom: 15%;
				            // background-color: red;
				            min-width: 60%;
				            height: 30%;
				            font-size: 1.3rem;
				            font-weight: 600;
				            color: #fff;
				            display: flex;
				            align-items: center;
				            letter-spacing: 1px;
				        }
				        .num-icon {
				            position: absolute;
				            right: 0;
				            // top: 15%;
				            width: 30%;
				            height: 100%;
				            // background-color: red;
				            display: flex;
				            justify-content: center;
				            align-items: center;
				        }
				    }
				    .title {
				        width: 100%;
				        height: 15%;
				        display: flex;
				        flex-direction: column;
				        justify-content: center;
				        align-items: center;
				    }
				    .top-left-cmp {
				        display: flex;
				        width: 100%;
				        height: 100%;
				        .dc-left, .dc-right {
				            width: 50%;
				        }
				        .dv-border-box-5 {
				            height: 60%;
				            // background-color: red;
				        }
				        .dc-text {
				            display: flex;
				            flex-direction: column;
				            height: 40%;
				            font-size: 20px;
				            padding: 20px;
				            box-sizing: border-box;
				            color: #fff;
				        }
				        .dc-left .dc-text {
				            align-items: flex-end;
				            justify-content: center;
				        }
				        .dc-right .dc-text {
				            justify-content: flex-start;
				            padding-top: 20px;
				        }
				        .dc-left .dv-border-box-5 {
				            padding: 30px;
				            box-sizing: border-box;
				        }
				        .dc-right .dv-border-box-5 {
				            padding: 40px;
				            padding-left: 75px;
				            box-sizing: border-box;
				        } 
				        .main-value {
				            font-weight: bold;
				            // font-size: 20px;
				            // background-color: red;
				            width: 100%;
				            height: 100%;
				            display: flex;
				            justify-content: center;
				            align-items: center;
				            // color: #fff;
				            font-size: 45px;
				            color: #00c0ff;
				        }
				    }
				}
				.map {
				    width: 50%;
				    height: 95.5%;
				}
				.right-top-echart {
				    width: 25%;
				    height: 100%;
				    position: relative;
				    .title-text {
						margin-top: -5%;
				        max-width:13rem;
				        min-width: 10rem;
				        padding: 0 1rem;
				        height: 90%;
				        color:#04d0f5;
				        font-size: 0.7rem;
				        display: flex;
				        align-items: center;
				        justify-content: center;
				        background-image: url(../../assets/datav-title.png);
				        background-size: 100% 100%;
				    }
				    .board {
				        width: 100%;
				        height: 95%;
				        padding-top: 0.7rem;
				        background-image: url(../../assets/right-echart-bg.png);
				        background-size: 100% 100%;
				        display: flex;
				        justify-content: center;
				        align-items: center;
				    }
				}
			}
			.next-part {
				width: 100%;
				height: 40%;
				display: flex;
				flex-direction: row;
				padding: 0 1%;
				.left-bottom-echart {
					width: 45%;
					height: 100%;
				}
				.right-bottom-echart {
					width: 55%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
        }
    }
    .title {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}
</style>